import type { Order } from '@/api/@types'

export const orderKeyFactory = {
  all: [{ scope: 'order' }] as const,
  unapprovedList: () =>
    [{ ...orderKeyFactory.all[0], entity: 'unapproved-list' }] as const,
  detail: ({ pathParams }: { pathParams: { orderNo: Order['orderNo'] } }) =>
    [{ ...orderKeyFactory.all[0], entity: 'detail', pathParams }] as const,
}
